const emptySocialFilter = {filterTarget: '', filterType: '', filterValue: ''};

export { emptySocialFilter };
